<section class="testimonials-section" aria-labelledby="testimonials-heading">
    <h3 id="testimonials-heading">{{strings.TESTIMONIALS_HEADING}}</h3>

    <div class="testimonials-live" aria-live="polite" aria-atomic="false">
        <ng-container *ngIf="(allTestimonials | async) as testimonials">
            <p *ngIf="testimonials.length === 0 && !testimonialsService.addingNewTestimonial" class="empty-state">
                {{strings.NO_TESTIMONIALS}}
            </p>

            <ul *ngIf="testimonials.length > 0" class="testimonials-list" role="list">
                <li *ngFor="let t of testimonials; trackBy: trackByUid" role="listitem" class="testimonial-item">
                    <ng-container *ngIf="testimonialsService.editingTestimonialUid !== t.uid; else editView">
                        <blockquote class="testimonial-quote">
                            <p>&ldquo;{{t.quote}}&rdquo;</p>
                            <footer>
                                <cite>
                                    <strong>{{t.reviewerName}}</strong>
                                    <span *ngIf="t.reviewerTitle"> &mdash; {{t.reviewerTitle}}</span>
                                </cite>
                            </footer>
                        </blockquote>
                        <div class="testimonial-actions" *ngIf="!bookService.keepFocus">
                            <button type="button" class="primary-button"
                                [attr.aria-label]="strings.EDIT_ARIA + ' ' + t.reviewerName"
                                (click)="startEdit(t)">{{strings.EDIT}}</button>
                            <button type="button" class="delete-button"
                                [attr.aria-label]="strings.DELETE_ARIA + ' ' + t.reviewerName"
                                (click)="removeTestimonial(t)">{{strings.DELETE}}</button>
                        </div>
                    </ng-container>

                    <ng-template #editView>
                        <form [formGroup]="editForm" class="testimonial-form"
                            [attr.aria-label]="strings.EDIT_TESTIMONIAL_FORM_HEADING">
                            <h4>{{strings.EDIT_TESTIMONIAL_FORM_HEADING}}</h4>
                            <label class="fixed-size" [attr.for]="'edit-reviewer-name-' + t.uid">{{strings.REVIEWER_NAME_LABEL}}</label>
                            <input [attr.id]="'edit-reviewer-name-' + t.uid" type="text" formControlName="reviewerName" required>
                            <br>
                            <label class="fixed-size" [attr.for]="'edit-reviewer-title-' + t.uid">{{strings.REVIEWER_TITLE_LABEL}}</label>
                            <input [attr.id]="'edit-reviewer-title-' + t.uid" type="text" formControlName="reviewerTitle">
                            <br>
                            <label [attr.for]="'edit-quote-' + t.uid">{{strings.QUOTE_LABEL}}</label><br>
                            <textarea [attr.id]="'edit-quote-' + t.uid" class="text-area-90"
                                style="background-color:rgb(255, 255, 255);color:rgb(0, 0, 0);" rows="6" cols="40"
                                formControlName="quote" required></textarea>
                            <br>
                            <button type="button" class="cancel-button" (click)="cancelEdit()">{{strings.CANCEL}}</button>
                            <button type="submit" class="primary-button" [disabled]="!editForm.valid"
                                (click)="submitEdit(t)">{{strings.SUBMIT}}</button>
                        </form>
                    </ng-template>
                </li>
            </ul>
        </ng-container>
    </div>

    <ng-container
        *ngIf="!testimonialsService.addingNewTestimonial && testimonialsService.editingTestimonialUid == null">
        <button *ngIf="!bookService.keepFocus" type="button" class="add-button"
            (click)="startAdd()">{{strings.ADD_TESTIMONIAL}}</button>
    </ng-container>

    <form *ngIf="testimonialsService.addingNewTestimonial" [formGroup]="newForm" class="testimonial-form"
        [attr.aria-label]="strings.ADD_TESTIMONIAL_FORM_HEADING">
        <h4>{{strings.ADD_TESTIMONIAL_FORM_HEADING}}</h4>
        <label class="fixed-size" for="new-reviewer-name">{{strings.REVIEWER_NAME_LABEL}}</label>
        <input id="new-reviewer-name" type="text" formControlName="reviewerName" required>
        <br>
        <label class="fixed-size" for="new-reviewer-title">{{strings.REVIEWER_TITLE_LABEL}}</label>
        <input id="new-reviewer-title" type="text" formControlName="reviewerTitle">
        <br>
        <label for="new-quote">{{strings.QUOTE_LABEL}}</label><br>
        <textarea id="new-quote" class="text-area-90"
            style="background-color:rgb(255, 255, 255);color:rgb(0, 0, 0);" rows="6" cols="40"
            formControlName="quote" required></textarea>
        <br>
        <button type="button" class="cancel-button" (click)="cancelAdd()">{{strings.CANCEL}}</button>
        <button type="submit" class="primary-button" [disabled]="!newForm.valid"
            (click)="submitAdd()">{{strings.SUBMIT}}</button>
    </form>
</section>
